// extracted by mini-css-extract-plugin
export default {"btnpwd":"_41975fc5be"};